export const NEW_OWNERSHIP = '[Ownership] New ownership';

export const CREATE_OWNERSHIP = '[Ownership] Create ownership';
export const CREATE_OWNERSHIP_SUCCESS = '[Ownership] Create ownership Success';
export const CREATE_OWNERSHIP_ERROR = '[Ownership] Create ownership Error';

export const UPDATE_OWNERSHIP_FIELD = '[Ownership] Update ownership field';

export const UPDATE_REQUEST_OWNERSHIP_FIELD =
  '[Ownership] update request ownership field';
export const UPDATE_REQUEST_OWNERSHIP_FIELD_SUCCESS =
  '[Ownership] update request ownership field success';
export const UPDATE_REQUEST_OWNERSHIP_FIELD_ERROR =
  '[Ownership] update request ownership field error';

export const GET_OWNERSHIPS = '[Ownership] Get owners';
export const GET_OWNERSHIPS_SUCCESS = '[Ownership] Get owners Success';
export const GET_OWNERSHIPS_ERROR = '[Ownership] Get owners Error';

export const GET_OWNERSHIPS_BY_USER_ID = '[Ownership] Get ownerships by userId';
export const GET_OWNERSHIPS_BY_USER_ID_SUCCESS =
  '[Ownership] Get ownerships by userId Success';
export const GET_OWNERSHIPS_BY_USER_ID_ERROR =
  '[Ownership] Get ownerships by userId Error';

export const UPDATE_OWNERSHIP = '[Ownership] Update ownership';
export const UPDATE_OWNERSHIP_SUCCESS = '[Ownership] Update ownership Success';
export const UPDATE_OWNERSHIP_ERROR = '[Ownership] Update ownership Error';

export const UPDATE_OWNERSHIP_ORDER = '[Ownership] Update ownership order';
export const UPDATE_OWNERSHIP_ORDER_SUCCESS =
  '[Ownership] Update ownership order Success';
export const UPDATE_OWNERSHIP_ORDER_ERROR =
  '[Ownership] Update ownership order Error';

export const REASSIGN_SPLITS = '[Ownership] Reassign Splits';
export const REASSIGN_SPLITS_SUCCESS = '[Ownership] Reassign Splits Success';
export const REASSIGN_SPLITS_ERROR = '[Ownership] Reassign Splits Error';
export const SAVE_ASSET_OWNERSHIPS = '[Ownership] Save Asset Ownerships';

export const REMOVE_OWNERSHIP = '[Ownership] Remove ownership';
export const REMOVE_OWNERSHIP_SUCCESS = '[Ownership] Remove ownership Success';
export const REMOVE_OWNERSHIP_ERROR = '[Ownership] Remove ownership Error';

export const REMOVE_MANAGER_OWNERSHIP = '[Ownership] Remove Manager ownership';
export const REMOVE_MANAGER_OWNERSHIP_SUCCESS =
  '[Ownership] Remove Manager ownership Success';
export const REMOVE_MANAGER_OWNERSHIP_ERROR =
  '[Ownership] Remove Manager ownership Error';

export const CLEAR_OWNERSHIP_STATE = '[Ownership] Clear ownership state';
